import React from 'react';
import { dataDrivenMatching } from '../assets/dataDrivenMatching';
import { carePrinciples } from '../data/carePrinciples';
export const CareMatchingSection: React.FC = () => {
  return <section id="care" aria-labelledby="care-heading" className="section-y bg-white" data-id="element-33" data-mp="109g9ssp6h3eu">
      <div className="section-container" data-id="element-34" data-mp="158szrmbciqln">
        <div className="grid grid-cols-1 items-center gap-10 border-t border-mist-sage/60 pt-12 md:pt-16 lg:grid-cols-[1.2fr_1fr] lg:gap-16 lg:pt-20" data-id="element-35" data-mp="159ksmpdk6a88">
          <div data-id="element-36" data-mp="1e8fxny4v9e9y">
            <h2 id="care-heading" className="section-heading max-w-[18ch]" data-id="element-37" data-mp="1e7wgwkqycvxi">
              Care starts with finding the right fit.
            </h2>
            <p className="section-lead mt-5" data-id="element-38" data-mp="1j20o9544r5z4">
              A therapist’s approach, the people in your group, and the
              practical details all matter. Re:Joy is being designed to bring
              those considerations together, so you can understand your options
              before deciding.
            </p>
          </div>
          <div className="flex justify-center lg:justify-end" data-id="element-39" data-mp="3d7eje8mn9syy">
            <img src={dataDrivenMatching} alt="Illustration representing thoughtful matching between people, therapists, and groups" className="h-auto w-[220px] object-contain md:w-[280px] lg:w-[320px]" data-id="element-40" data-mp="3d4s23h9ybz3j" />
          </div>
        </div>

        <ul className="mt-12 grid grid-cols-1 gap-8 md:mt-16 md:grid-cols-3 md:gap-6" data-id="element-41" data-mp="2z9g85c3mecno">
          {carePrinciples.map(point => <li key={point.title} className="border-l-2 border-mist-sage pl-5" data-id="element-42" data-mp="3qyszo7p63g2b">
              <h3 className="text-xl" data-id="element-43" data-mp="3m7t6ndj65i53">{point.title}</h3>
              <p className="mt-2 leading-relaxed text-plum-gray" data-id="element-44" data-mp="3m6i1b9a2s2bv">
                {point.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
};